// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jhIQ8","questions":"styles_questions__1T_fn","footer":"styles_footer__oCkb7"};